<template>
  <el-col :span="24" class="chat">
    <div
      class="chat-item"
      v-for="(item, index) in chatData.chatlist"
      :key="item.recordId"
    >
      <div class="photo">
        <!-- 头像 -->
        <el-tooltip
          class="item"
          effect="dark"
          :disabled="!chatPhoto(item).tooltipName"
          :content="chatPhoto(item).tooltipName"
          placement="top-start"
        >
          <img :src="chatPhoto(item).photo" />
        </el-tooltip>
      </div>
      <div class="info-detail">
        <div class="message">
          <div class="info-data">
            <!-- 名称 -->
            <div class="name">
              {{ chatPhoto(item).name }}
            </div>
            <!-- 日期 -->
            <div class="date" v-show="item.showDate">{{ item.sendTime }}</div>
          </div>
          <!-- 内容 -->
          <div class="info-content">
            <span
              class="content"
              :class="{
                self: item.senderType === 2 && item.type === 1,
                text: item.type === 1,
                image: item.type === 2,
                warn: item.type !== 1 && item.type !== 2 && item.type !== 5,
              }"
              @mouseenter="enter(item, index)"
              @mouseleave="leave(item, index)"
            >
              <!-- 文本 -->
              <strong class="text" v-if="item.type == 1">
                {{ item.content }}
              </strong>
              <!-- 图片 -->
              <template v-for="(img, idx) in item.urls">
                <img
                  class="image"
                  :src="img"
                  :key="idx"
                  v-if="item.type == 2"
                />
              </template>
              <!-- 按钮 -->
              <div class="modal" v-if="item.type == 5">
                <div class="title">
                  {{ item.temp.cpmTitle }}
                </div>
                <div class="btn-box">
                  <el-button
                    size="mini"
                    :type="item.temp.result == 2 ? 'primary' : ''"
                    >{{ item.temp.leftTitle }}</el-button
                  >
                  <el-button
                    size="mini"
                    :type="item.temp.result == 1 ? 'primary' : ''"
                    >{{ item.temp.rightTitle }}</el-button
                  >
                </div>
              </div>
              <!-- 未知类型 -->
              <strong
                class="text"
                v-if="item.type !== 1 && item.type !== 2 && item.type !== 5"
              >
                未知消息类型
              </strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: 'chat-item',
  props: ['chatData'],
  data() {
    return {};
  },
  methods: {
    enter(item, index) {
      this.$set(this.chatData.chatlist[index], 'showDate', true);
      this.$store.dispatch('setfbmessagechat', this.chatData);
    },
    leave(item, index) {
      this.$set(this.chatData.chatlist[index], 'showDate', false);
      this.$store.dispatch('setfbmessagechat', this.chatData);
    },
    // 头像
    chatPhoto(item) {
      let user = {
        name: '',
        photo: '',
      };
      if (item.senderType == 1) {
        user.name = this.chatData.fbName;
        user.photo = this.chatData.fbThumb || '@/assets/default.png';
      } else if (item.senderType == 2) {
        user.name = '我的主页';
        user.tooltipName = this.chatData.cnickname;
        user.photo = this.chatData.cthumb || '@/assets/default.png';
      } else {
        user.name = '未知';
        user.photo = '@/assets/default.png';
      }

      return user;
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.chat {
  padding: 0 30px;
  .chat-item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 30px;
    margin-bottom: 30px;
    .photo {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info-detail {
      width: 100%;
      .message {
        max-width: 90%;
        color: #333;
        .info-data {
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
          font-size: 12px;
          margin-bottom: 10px;
          .name {
            max-width: 80%;
            // 单行溢出
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .date {
            width: 130px;
            text-align: right;
            color: #999;
          }
        }
        .info-content {
          font-size: 14px;
          line-height: 20px;
          .content {
            min-width: 300px;
            display: inline-block;
            box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
            border-radius: 6px;
            .text {
              word-break: break-all;
              line-height: 20px;
            }
            .image {
              padding: 0;
              background: none;
              box-shadow: none;
              vertical-align: top;
              width: 200px;
              margin-right: 10px;
              border-radius: 6px;
            }
            .modal {
              min-width: 300px;
              max-width: 600px;
              height: 123px;
              padding: 0;
              background: #fff;
              border: 1px solid #e8e8e8;
              border-radius: 6px;
              .title {
                width: 100%;
                height: 60px;
                padding: 10px;
                text-align: center;
                line-height: 20px;
                border-bottom: 1px solid #e8e8e8;
                display: flex;
                justify-content: center;
                align-items: center;
                word-break: break-all;
                overflow: hidden;
              }
              .btn-box {
                width: 100%;
                height: 62px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                position: relative;
                .el-button {
                  width: 100%;
                  // 单行溢出
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin: 0 10px;
                  // color: #606266;
                  // border: 1px solid #dcdfe6;
                }
                &::after {
                  content: '';
                  width: 1px;
                  height: 62px;
                  background-color: #e8e8e8;
                  position: absolute;
                  top: 0;
                  left: 50%;
                }
              }
            }
          }
          .content.text {
            padding: 15px 20px;
            background-color: #f9f9f9;
          }
          .content.self {
            color: #fff;
            background-color: #3da1ff;
          }
          .content.image {
            box-shadow: none;
          }
          .content.warn {
            padding: 15px 20px;
            background-color: #fffbe5;
          }
        }
      }
    }
  }
}
</style>
